<template>
    <div class="form">
        <Form
            ref="info"
            :model="info"
            :label-width="80"
            :rules="ruleValidate"
            :viewonly="false"
        >
            <!-- 租客 姓名手机号 -->
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="cusId" label="租客姓名">
                        <Select
                            v-model="info.cusId"
                            transfer
                            @on-change="onCusIdChange"
                        >
                            <Option
                                v-for="item in customerList"
                                :key="item.id"
                                :value="item.id"
                                :label="item.cusName"
                                >{{ item.cusName }} {{ item.cusMobile }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="cusMobile" label="手机号" disabled>
                        <Input v-model="info.cusMobile"></Input>
                    </FormItem>
                </Col>
            </Row>
            <!-- 租客身份 -->
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="cusType" label="租客身份">
                        <check-tag-group
                            style="display: inline-block"
                            v-model="cusType"
                            color="primary"
                            @on-change="onCusTypeChange"
                        >
                            <check-tag
                                v-for="item in dict.cusType.toList()"
                                :name="item.id"
                                :key="item.id"
                                >{{ item.text }}</check-tag
                            >
                        </check-tag-group>
                    </FormItem>
                </Col>
            </Row>
            <!-- 单位信息 -->
            <div v-if="info.cusType === '2'">
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem prop="comName" label="单位名称">
                            <Input v-model="info.comName"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem prop="taxNum" label="税号">
                            <Input v-model="info.taxNum"></Input> </FormItem
                    ></Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem prop="addr" label="单位地址">
                            <Input v-model="info.addr"></Input> </FormItem
                    ></Col>
                    <Col span="12">
                        <FormItem prop="comTel" label="公司电话">
                            <Input v-model="info.comTel"></Input> </FormItem
                    ></Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem prop="bank" label="开户银行">
                            <Input v-model="info.bank"></Input> </FormItem
                    ></Col>
                    <Col span="12">
                        <FormItem prop="account" label="银行账号">
                            <Input v-model="info.account"></Input> </FormItem
                    ></Col>
                </Row>
            </div>
            <!-- 个人信息 -->
            <div v-else>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem prop="sex" label="租客性别">
                            <RadioGroup v-model="info.sex">
                                <Radio
                                    v-for="(item, index) in this.$enum
                                        .get('sex')
                                        .toList()"
                                    :key="index"
                                    :label="item.id"
                                    >{{ item.text }}</Radio
                                >
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem prop="credType" label="证件类型">
                            <card-type
                                spread-out
                                :credType="credType.credType"
                                :credNo="credType.credNo"
                                @on-change="onCardTypeChange"
                            />
                        </FormItem>
                    </Col>
                </Row>
            </div>
            <!-- 说明 -->
            <div class="notice">
                <p><strong>说明：</strong></p>
                <p>1、系统不支持直接修改手机号。</p>
                <p>
                    2、如需修改手机号，请在【客户管理】中创建新的客户，再在此界面选择该客户完成修改，注意解除原客户微信绑定，邀请绑定到新客户。
                </p>
            </div>
        </Form>
    </div>
</template>

<script>
import Dict from '_u/dict'
import Enum from '_u/enum'
import { cInfoList, getLastContractCus } from '@/api/customer'
import CardType from '_v/components/fields/card-type'
import { tel } from '_u/validate'
import { idCardCheck } from '@/api/sys-user'
import { cusUpdate, cusView } from '@/api/contract'

const CUS_TYPE = Enum.get('CUS_TYPE')

export default {
    props: {
        id: {
            type: [Number, String],
            default: '',
        },
    },
    components: { CardType },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                id: '', // 租户数据编号
                contractId: '', // 合同编号编号
                cusType: '', // 客户类型
                cusId: '', // 客户数据编号
                cusName: '', // 客户姓名
                cusMobile: '', // 客户手机号
                sex: '', // 性别
                credType: '', // 证件类型
                credNo: '', // 证件号码
                comName: '', // 公司名称
                comTel: '', // 公司电话
                taxNum: '', // 税号
                addr: '', // 公司地址
                bank: '', // 开户银行
                account: '', // 银行账户
                ver: '',
            },
            customerList: [], // 租户列表
            dict: {
                cusType: Dict.NULL,
                credType: Dict.NULL,
            },
            credType: { credType: '', credNo: '' },
        }
    },
    computed: {
        cusType: {
            get() {
                return this.info.cusType ? this.info.cusType.split(',') : []
            },
            set(val) {
                this.info.cusType = val.join(',')
            },
        },
        ruleValidate() {
            let rules = {}
            // 个人
            if (this.info.cusType === CUS_TYPE.personal) {
                _.assign(rules, {
                    cusId: [{ required: true, message: '客户名称必填' }],
                    cusMobile: [
                        { required: true, message: '手机号必填' },
                        { validator: tel, message: '手机号格式不正确' },
                    ],
                    // prettier-ignore
                    credType: {
                                credType: [
                                    { required: true, message: '证件类型不能为空', },
                                ],
                                credNo: [
                                    { required: true, message: '证件号码不能为空' },
                                    { validator: this.checkCredNo, trigger: 'blur' },
                                ],
                            },
                })
            }
            // 单位
            if (this.info.cusType === CUS_TYPE.company) {
                _.assign(rules, {
                    cusMobile: [
                        { required: true, message: '手机号必填' },
                        { validator: tel, message: '手机号格式不正确' },
                    ],
                    comName: [{ required: true, message: '单位名称必填' }],
                    taxNum: [{ required: true, message: '税号必填' }],
                })
            }
            return rules
        },
    },
    methods: {
        // 切换客户类型
        onCusTypeChange(val) {},
        // 客户更改
        onCusIdChange(id) {
            getLastContractCus({ cusId: id }).then((res) => {
                const obj = res.data.entity
                if (obj) {
                    // console.log(obj)
                    this.info.cusName = obj.cusName
                    this.info.cusMobile = obj.cusMobile
                    this.info.cusType = obj.cusType
                    // 个人
                    this.info.sex = obj.sex
                    this.credType.credType = obj.credType
                    this.credType.credNo = obj.credNo
                    // 单位
                    this.info.comName = obj.comName
                    this.info.taxNum = obj.taxNum
                    this.info.addr = obj.addr
                    this.info.comTel = obj.comTel
                    this.info.bank = obj.bank
                    this.info.account = obj.account
                } else {
                    // 无信息 默认个人身份
                    this.info.cusType = '1'
                    const customer = this.customerList.find((v) => v.id === id)
                    if (customer) {
                        this.info.cusMobile = customer.cusMobile
                        this.info.cusName = customer.cusName
                        this.info.credNo = customer.idCard
                        this.credType.credType = '1'
                        this.credType.credNo = customer.idCard
                    }
                }
            })
        },
        // 证件类型切换
        onCardTypeChange(val) {
            this.info.credType = val.credType
            this.info.credNo = val.credNo
        },
        // 证件号码校验
        checkCredNo(rule, value, callback) {
            var credTypeText = this.dict.credType.val(this.info.credType)

            // 只校验身份证的长度，其他类型不做校验，不为空即可
            if (value && credTypeText === '身份证') {
                var msg = '请输入正确的身份证号码'

                // 排除空值
                if (value == '' || value == null || value == undefined) {
                    return Promise.resolve().then(() => callback())
                }

                idCardCheck(value)
                    .then(() => callback())
                    .catch(() => callback(new Error(msg)))
            } else {
                callback()
            }
        },
    },
    mounted() {
        var $info = this.$refs.info
        // 按钮配置
        var btns = [{ type: 'default', text: '取消', name: 'cancel' }]
        if (this.$can('update')) {
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)
        this.$modal.beforeEnter((next) => {
            Promise.all([
                Dict.get(['cus_type', 'cred_type']),
                cInfoList({ pageNo: 1, pageSize: 999 }),
                cusView(this.id),
            ])
                .then((args) => {
                    var [dictGroup, customer, view] = args
                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })
                    this.customerList = customer.data.page.list
                    let viewData = view.data.entity
                    Object.keys(this.info).forEach(
                        (name) => (this.info[name] = viewData[name])
                    )

                    this.credType.credType = this.info.credType
                    this.credType.credNo = this.info.credNo
                })
                .finally(() => {
                    next()
                })
        })
        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    let formData = {}
                    if (this.info.cusType == 1) {
                        formData = {
                            id: this.info.id,
                            contractId: this.info.contractId,
                            cusType: this.info.cusType,
                            cusId: this.info.cusId,
                            cusName: this.info.cusName,
                            cusMobile: this.info.cusMobile,
                            sex: this.info.sex,
                            credType: this.info.credType,
                            credNo: this.info.credNo,
                            ver: this.info.ver,
                        }
                    } else {
                        formData = {
                            id: this.info.id,
                            contractId: this.info.contractId,
                            cusType: this.info.cusType,
                            cusId: this.info.cusId,
                            cusName: this.info.cusName,
                            cusMobile: this.info.cusMobile,
                            comName: this.info.comName,
                            comTel: this.info.comTel,
                            taxNum: this.info.taxNum,
                            addr: this.info.addr,
                            bank: this.info.bank,
                            account: this.info.account,
                            ver: this.info.ver,
                        }
                    }

                    return cusUpdate(formData)
                })
                .then((res) => {
                    this.$Message.success(this.$t('tips.update.success'))
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>

<style lang="less" scoped>
.notice {
    margin: 40px;
}
</style>
